// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
import { CURRENT_WHATS_NEW_VERSION } from './utils/whatsNewVersion';

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'it'],
    debug: process.env.NODE_ENV === 'development',

    ns: [
      'common', 'main-layout', 'billing', 'driver', 'team', 'inventory',
      'garage', 'workshop', 'track', 'setup_template', 'category', 'supplier',
      'auth', 'create_team', 'event', 'checklist', 'vehicle', 'issue', 'lifing',
      'tires', 'race_engineer'
    ],

    defaultNS: 'common',

    react: {
      useSuspense: true,
    },

    backend: {
      // Cache buster: bustare CURRENT_WHATS_NEW_VERSION a ogni rilascio
      // forza il browser a ri-scaricare i file JSON delle traduzioni.
      loadPath: `/locales/{{lng}}/{{ns}}.json?v=${CURRENT_WHATS_NEW_VERSION}`,
    },
  });

export default i18n;